"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApplicableRateDiscountsByDateAndNights = void 0;
const extractUniqueDiscountPolicies_1 = require("./extractUniqueDiscountPolicies");
const findDiscountPolicyWithLowestHighestDiscount_1 = require("./findDiscountPolicyWithLowestHighestDiscount");
const getApplicableRateDiscountsByDateAndNights = (data, check_in_date, number_of_nights) => {
    const discount_policies = (0, extractUniqueDiscountPolicies_1.extractUniqueDiscountPolicies)(data);
    if (discount_policies.length === 0) {
        return {
            reference: "NO_DISCOUNT_POLICIES",
            stackable: false,
            long_stay_discount: null,
            early_bird_discount: null,
            total_discount_percentage: 1,
        };
    }
    const discount_policy = (0, findDiscountPolicyWithLowestHighestDiscount_1.findDiscountPolicyWithLowestHighestDiscount)(discount_policies);
    if (!discount_policy)
        return {
            reference: "NO_DISCOUNT_POLICIES",
            stackable: false,
            long_stay_discount: null,
            early_bird_discount: null,
            total_discount_percentage: 1,
        };
    const days_until_check_in = Math.floor((new Date(check_in_date).getTime() - new Date().getTime()) /
        (1000 * 60 * 60 * 24));
    let long_stay_discount = null;
    const filtered_long_stay_discounts = discount_policy.long_stay_discounts.filter((discount) => discount.min_nights <= number_of_nights);
    if (filtered_long_stay_discounts.length > 0) {
        long_stay_discount = filtered_long_stay_discounts.reduce((prev, current) => {
            return prev.min_nights > current.min_nights ? prev : current;
        });
    }
    let early_bird_discount = null;
    const filtered_early_bird_discounts = discount_policy.early_bird_discounts.filter((discount) => discount.min_days_in_advance <= days_until_check_in);
    if (filtered_long_stay_discounts.length === 0 &&
        filtered_early_bird_discounts.length === 0) {
        return {
            reference: discount_policy.reference,
            stackable: discount_policy.stackable,
            long_stay_discount: null,
            early_bird_discount: null,
            total_discount_percentage: 1,
        };
    }
    if (filtered_early_bird_discounts.length > 0) {
        early_bird_discount = filtered_early_bird_discounts.reduce((prev, current) => {
            return prev.min_days_in_advance > current.min_days_in_advance
                ? prev
                : current;
        });
    }
    if (discount_policy.stackable) {
        let total_discount_percentage = 0;
        // the total discount percentage is the product of the 1-long stay and 1-early bird discounts displayed as a decimal
        if (long_stay_discount) {
            total_discount_percentage =
                1 - long_stay_discount.discount_percentage / 100;
        }
        if (early_bird_discount) {
            total_discount_percentage *=
                1 - early_bird_discount.discount_percentage / 100;
        }
        return {
            reference: discount_policy.reference,
            stackable: discount_policy.stackable,
            long_stay_discount: long_stay_discount,
            early_bird_discount: early_bird_discount,
            total_discount_percentage: total_discount_percentage,
        };
    }
    // NOT STACKABLE
    // If there are both long stay and early bird discounts, return the one with the highest discount
    if (long_stay_discount && early_bird_discount) {
        const isLongStayDiscountHigher = long_stay_discount.discount_percentage >=
            early_bird_discount.discount_percentage;
        let total_discount_percentage = 0;
        if (isLongStayDiscountHigher) {
            total_discount_percentage =
                1 - long_stay_discount.discount_percentage / 100;
        }
        else {
            total_discount_percentage =
                1 - early_bird_discount.discount_percentage / 100;
        }
        return {
            reference: discount_policy.reference,
            stackable: discount_policy.stackable,
            long_stay_discount: isLongStayDiscountHigher ? long_stay_discount : null,
            early_bird_discount: isLongStayDiscountHigher
                ? null
                : early_bird_discount,
            total_discount_percentage: total_discount_percentage,
        };
    }
};
exports.getApplicableRateDiscountsByDateAndNights = getApplicableRateDiscountsByDateAndNights;
